import React from 'react';
import { DeleteOutline, MoreVertRounded, ArrowBack } from '@mui/icons-material';
import TooltipIconButton from "components/TooltipIconButton";
import SidebarHeader from '../../layout/SidebarHeader';
// import ButtonIcon from '../../../ButtonIcon';


const Header = ({ projectID, deletefunction, onClose, onBack, edit, returnToOriginalPage }) => {
  // TO DO - add delete + more menu functionality
  const deletefunc = (projectId) => {
    //setDescription(e.target.value);
    deletefunction(projectId);
  };
  return (
    <>
      <SidebarHeader onClose={onClose} edit={edit} returnToOriginalPage={returnToOriginalPage} >
        {/* <TooltipIconButton title="Delete" ariaLabel="delete" placement="bottom" onClick={() => { deletefunc(projectID) }} size={44}>
          <DeleteOutline />
        </TooltipIconButton> */}
        <TooltipIconButton title="Back" ariaLabel="back" placement="bottom" onClick={onBack} size={44}>
          <ArrowBack />
        </TooltipIconButton>
        {/* <ButtonIcon noBg><MoreVertRounded /></ButtonIcon> */}
      </SidebarHeader>
    </>
  );
}

export default Header;